import React, { useEffect, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';

import swal from "sweetalert";
import { Modal } from 'react-bootstrap';
import { nanoid } from 'nanoid';
import { updateCategoryType } from '../../../services/superadminService/CategoreyType';
import { DTActionDialog, DTInpurTfiled, PurpleButton } from '../../../common/ui/view/CustomButton';
import * as Yup from 'yup';
const CategoryUpdateModal = ({ showEditModal, setShowEditModal, ClientId, categoryidList, CategoryList, userCategory, fetchUpdate, CategoryOptions,categoryIdField ,categoryLabel,setCurrentPage}) => {
    
    const [initialValues, setInitialValues] = useState({
        category: '',
        category_id: '',
        status: '',
        slug: '',
    });

    useEffect(() => {
        if (categoryidList) {
            setInitialValues({
                category: categoryidList?.category_name || '',
                category_id: categoryidList?.user_category_main_id || categoryidList?.user_level_id ||'',
                status: categoryidList?.active_status || '',
                slug: categoryidList?.slug || '',
            });
        }
    }, [categoryidList]);

    const validationSchema = Yup.object({
        category: Yup.string().required('Please fill category name'),
        category_id: Yup.string().required('Please select user category main.'),
        status: Yup.string().required('Please select status'),
        slug: Yup.string().required('Please fill slug'),
    });

    const handleFormSubmit = async (values, { setSubmitting, setErrors }) => {
        const editData = {
            category_name: values.category,
            [categoryIdField]: values.category_id,
            active_status: values.status,
            has_child: 0,
            slug: values.slug,
        };

        try {
            const response = await fetchUpdate(editData, ClientId);
            if (response?.data?.status === true) {
                swal(`${response?.data?.message}`);
                setCurrentPage(1)
                CategoryList();
                setShowEditModal(false);
               
            } else {
                swal('Oops', response?.data?.message, "error");
            }
        } catch (error) {
            console.log("error", error);
            swal('Oops', 'An unexpected error occurred. Please try again.', "error");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal className="modal fade" show={showEditModal} onHide={() => setShowEditModal(false)}>
            <div role="document">
                <div>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                    >
                        {({ isSubmitting, setFieldValue }) => (
                            <Form>
                                <div className="modal-header">
                                    <h4 className="modal-title fs-20">Edit Category</h4>
                                    <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}><span></span></button>
                                </div>
                                <div className="modal-body">
                                    <div className="add-contact-box">
                                        <div className="add-contact-content">
                                            <div className="row">
                                                <div className="form-group mb-3 col-md-6">
                                                    <label className="text-black font-w500">Category Name</label>
                                                    <Field type="text" name="category" className="form-control" placeholder="Category Name" />
                                                    <ErrorMessage name="category" component="div" className="validation-text" />
                                                </div>
                                                <div className="form-group mb-3 col-md-6">
                                                    <label className="text-black font-w500">{categoryLabel}</label>
                                                    <Field as="select" name="category_id" className="form-control">
                                                        <option value="" disabled>Select category</option>
                                                        {/* {userCategory?.data?.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.main_category_name}</option>
                                                        ))} */}
                                                        {CategoryOptions?.map((item) => {
                                                           
                                                            return (
                                                                <>
                                                                    <option key={item.id} value={item.id}>{item.main_category_name}</option>
                                                                </>
                                                            )

                                                        })}
                                                    </Field>
                                                    <ErrorMessage name="category_id" component="div" className="validation-text" />
                                                </div>
                                                <div className="form-group mb-3 col-md-6">
                                                    <label className="text-black font-w500">Status</label>
                                                    <Field as="select" name="status" className="form-control">
                                                        <option value="" disabled>Select status</option>
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </Field>
                                                    <ErrorMessage name="status" component="div" className="validation-text" />
                                                </div>
                                                <div className="form-group mb-3 col-md-6">
                                                    <label className="text-black font-w500">Slug</label>
                                                    <Field type="text" name="slug" className="form-control" placeholder="Slug"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const formattedSlug = value.replace(/\s+/g, '-').toLowerCase(); // Replaces spaces with hyphens
                                                            setFieldValue('slug', formattedSlug); // Updates Formik's state
                                                        }}
                                                    />
                                                    <ErrorMessage name="slug" component="div" className="validation-text" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Update</button>
                                    <button type="button" onClick={() => setShowEditModal(false)} className="btn btn-danger">Discard</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
};

export default CategoryUpdateModal;
